import { styled } from '@mui/system'
import Button from '../../../molecules/button'

const Root = styled('div')`
	margin: auto;
	max-width: 732px;
	padding: 0px 24px 38px;
	text-align: center;
	& tr {
		& td {
			&:last-of-type {
				display: flex;
				justify-content: flex-end;
				${({ theme }) => theme.breakpoints.up('lg')} {
					display: table-cell;
				}
			}
		}
	}
`

const ButtonStyled = styled(Button)`
	padding: 8px;
`

export { Root, ButtonStyled }
